/**
 * @deprecated use FEATURE_TYPE_TO_COLORS instead.
 */
export const GoJsProductColors = {
  Light: {
    Integration: '#7f4eff',
    Model: '#579c73',
    Visualization: '#af5d2a',
    Widget: '#14b5d0',
    Export: '#f3df5c',
  },
  Dark: {
    Integration: '#c62FA7',
    Model: '#1BABB6',
    Visualization: '#7AA012',
    Widget: '#30A5DD',
    Export: '#E87F44',
  },
};
